/* eslint-disable eqeqeq */
import { Message } from 'element-ui'
const vxFormPlugin = {}

vxFormPlugin.install = Vue => {
  Vue.prototype.$vxForm = {
    isValid: async function (validator, useAlert = true) {
      const { isValid, errors } = await validator.validateWithInfo()
      if (isValid == false) {
        for (const key in errors) {
          if (errors[key].length) {
            if (useAlert) {
              Message({
                message: errors[key][0],
                type: 'error',
                duration: 5 * 1000
              })
            }
            return isValid
          }
        }
      }
      return true
    },
    isChanged: async function (validator) {
      const res = await validator.validateWithInfo()
      const changeStt = res.flags.changed
      return changeStt
    }
  }
}
export default vxFormPlugin
